import { render, staticRenderFns } from "./DayPanel.vue?vue&type=template&id=6d28d8e6&scoped=true&"
import script from "./DayPanel.vue?vue&type=script&lang=js&"
export * from "./DayPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28d8e6",
  null
  
)

export default component.exports